import { useState } from "react";
import Layout2 from "@/components/Layout/Layout2";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@radix-ui/react-separator";
import OverviewTab from "./tabs/overview";
import GrandReportTab from "./tabs/grand-report";

function GrandReport() {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <Layout2
      pageName={{ icon: true, title: "Grand Report" }}
      paths={[
        { name: "Home", path: "/home" },
        { name: "Back Office", path: "/backoffice/overview" },
        { name: "Reporting", path: "/reporting" },
        { name: "Grand Report", path: "/reporting/grand-report" },
      ]}
    >
      <div className="container">
        <Tabs
          valueKey="reporting-grand-report"
          defaultValue="overview"
          value={activeTab}
          onValueChange={setActiveTab}
          className="bg-transparent relative mt-5"
        >
          <TabsList className="bg-transparent">
            <Separator className="absolute top-8" />
            <TabsTrigger className="" value="overview">
              Overview
            </TabsTrigger>
            <TabsTrigger className="" value="grand-report">
              Grand Report
            </TabsTrigger>
          </TabsList>
          <Separator className="absolute top-8 w-full h-[1px] bg-cblack6" />
          
          <OverviewTab isActive={activeTab === "overview"} />
          <GrandReportTab isActive={activeTab === "grand-report"} />
        </Tabs>
      </div>
    </Layout2>
  );
}

export default GrandReport;
